// extracted by mini-css-extract-plugin
module.exports = {"layoutBase":"base_layoutBase_Yal-u"};